import {WidgetStateEvents,} from "../../Events/Widget/State";
import {SessionEvents} from "../../Events/Session";
import {ABTesterEvents} from "../../Events/ABTester/Events";
import {AffiliateLinkEvents} from "../../Events/AffiliateLink/Events";
import {CheckoutEvents} from "../../Events/Checkout/events";
import {ChatBotEvents} from "../../Events/ChatBot/Events";
import {TriggerLayoutEvents} from "../../Events/Widget/TriggerLayout";
import {TriggerVisibilityEvents} from "../../Events/Widget/TriggerVisibility";

type EventMap = SessionEvents & WidgetStateEvents & ABTesterEvents & CheckoutEvents & AffiliateLinkEvents & ChatBotEvents & TriggerLayoutEvents & TriggerVisibilityEvents;

export class EventEmitterService<T extends Record<string, any>> {
    private listeners: { [K in keyof T]?: Array<(payload: T[K]) => void> } = {};

    // Emit an event with a payload
    emit<K extends keyof T>(eventName: K, payload: T[K]) {
        const eventListeners = this.listeners[eventName];
        if (eventListeners) {
            eventListeners.forEach(listener => listener(payload));
        }
    }
    // Listen to an event
    listen<K extends keyof T>(eventName: K, callback: (payload: T[K]) => void): void {
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName]!.push(callback);
    }
    // Remove a specific listener
    off<K extends keyof T>(eventName: K, callback: (payload: T[K]) => void): void {
        const arr = this.listeners[eventName];
        if (!arr) return;
        const idx = arr.indexOf(callback);
        if (idx !== -1) {
            arr.splice(idx, 1);
        }
    }
}

export const GlobalEventBus = new EventEmitterService<EventMap>();
